import React, { useState, useEffect } from 'react'
import { Row, Col, Modal, Card, Form, Button, InputGroup } from 'react-bootstrap'
import Orderdetails from './Orderdetails/Orderdetails'
import VendorProductdetails from './Venderrecive/VenderProductdetails'
import VendorManufactureProductdetails from './Venderrecive/VendorManufactureProductdetails'
import Table from 'react-bootstrap/Table'
import Rawmaterial from './Venderrecive/Rawmaterial'
import Actualrecivehistorydetails from './Venderrecive/Actualrecivehistory/Actualrecivehistory'
import Venderpayment from './Venderrecive/Venderpayment/Venderpayment'
import Customerpayment1 from './Venderrecive/Venderpayment/Customerpayment'
import Paymentdetails from './Venderrecive/Venderpayment/Paymentdetails'
import Vendorreportfile from './Venderrecive/Venderpayment/Vendorreportfile'
import Ordertakeprocessing from './Venderrecive/OrdertakeProcessing/Ordertakeprocessing'
import Billsdetails from './Venderrecive/OrdertakeProcessing/Billsdetails'
import Shippinghistory from './Venderrecive/OrdertakeProcessing/Shippinghistory'
import Customerpayment from './Venderrecive/OrdertakeProcessing/Customerpayment'
import Paymentreport from './Venderrecive/OrdertakeProcessing/Paymentreport'
import Vendorproduct2 from './Venderrecive/Vendorproduct2'
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast, ToastContainer } from 'react-toastify';

const Orderview = () => {
    const [tabs, setTabs] = useState(0);
    const token = localStorage.getItem('token');
    const [orderList, setOrderList] = useState([]);
    const [productDetails, setProductDetails] = useState({});
    const tabsclick = (index) => {
        setTabs(index);
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {

        fetchOrderlist();


    }, [token]);
    const fetchOrderlist = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Crete-custumer-product-name-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const orders = response.data.data || [];
            console.warn("dfgdf", orders);

            // Filter orders where manufacture is 'Trading'
            const filteredOrders = orders.filter(order => order.manufacture === 'Trading');
            console.warn("Filtered Orders: ", filteredOrders);

            setOrderList(orders);

            const initialDetails = {};
            filteredOrders.forEach(order => {
                const customerName = order.customer_name;
                const manufacture = order.manufacture;

                setProductDetails(prevFields => ({
                    ...prevFields,
                    CustumerName: customerName,
                    manufacture: manufacture,
                }));

                order.product_data.forEach(product => {
                    initialDetails[product.vdr_id] = {
                        product_id: product.product_id,
                        order_id: product.order_id,
                        vender_id: product.vender_id,
                        qty: product.qty,
                        unit_price: product.unit_price,
                        date: product.date,
                        manufacture: product.manufacture,
                        customerName,
                    };
                });
                console.warn(initialDetails);
            });
            // setProductDetails(initialDetails);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    const handleAction = async (payload) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Row-Matrials-store-price`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                // toast.success(response.data.message);
                fetchOrderlist();
            } else {
                // toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };


    return (
        <section className='orderview_section'>
            {/* <div className="page-header">
                <div className="add-item d-flex">
                    <div className="page-title">
                        <h4>Order View</h4>
                        <h6>Manage Order View</h6>
                    </div>
                </div>

                <div className="page-btn d-flex gap-2">

                </div>
            </div> */}
            <Card className="min_height">
                <Card.Header className="d-flex justify-content-between">
                    <Card.Title className='mb-0'>Order View</Card.Title>
                    <div className='d-flex gap-2'>
                        <button onClick={() => tabsclick(0)} className={tabs === 0 ? 'btn-added' : 'btn_tab_active'}>Order Details</button>
                        <button onClick={() => tabsclick(1)} className={tabs === 1 ? 'btn-added' : 'btn_tab_active'}>Vendor Trading Receive</button>
                        <button onClick={() => tabsclick(2)} className={tabs === 2 ? 'btn-added' : 'btn_tab_active'}>Vendor Manufacture Receive</button>
                        {/* <button onClick={() => tabsclick(2)} className={tabs === 2 ? 'btn-added' : 'btn_tab_active'}>Vendor Payment</button> */}
                        <button onClick={() => tabsclick(4)} className={tabs === 4 ? 'btn-added' : 'btn_tab_active'}>Customer Payment</button>
                        <button onClick={() => tabsclick(3)} className={tabs === 3 ? 'btn-added' : 'btn_tab_active'}>Order Processing</button>
                    </div>
                </Card.Header>
                <Card.Body >
                    {tabs === 0 && (
                       <>
                        <Orderdetails />
                    
                        </>  
                    )}
                    {tabs === 1 && (
                        <div id="venderrecive">
                            <VendorProductdetails />
                            {/* <Rawmaterial /> */}
                            {/* <hr /> */}
                            {/* <Actualrecivehistorydetails /> */}
                        </div>
                    )}
                    {tabs === 2 && (
                        <div id="venderrecive">
                            <VendorManufactureProductdetails />
                            {/* <Rawmaterial /> */}
                            {/* <hr /> */}
                            {/* <Actualrecivehistorydetails /> */}
                        </div>
                    )}
                    {/* {tabs === 2 && (
                        <div >
                            <Venderpayment />
                        </div>
                    )} */}
                    {tabs === 4 && (
                        <div >
                            <Customerpayment1 />


                        </div>
                    )}
                    {tabs === 3 && (
                        <>
                            <Ordertakeprocessing />
                            <hr />
                            {/* <Billsdetails /> */}
                            {/* <hr /> */}
                            {/* <Shippinghistory /> */}
                            {/* <hr /> */}
                            {/* <Customerpayment /> */}
                            {/* <hr /> */}
                            {/* <Paymentreport /> */}
                        </>
                    )}
                 
                </Card.Body>
            </Card>
            <>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Order View</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    placeholder="Price"
                                    aria-label="Price"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                            <InputGroup>
                                <Form.Control
                                    placeholder="Vendor Name"
                                    aria-label="s Price"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleClose}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        </section>

    )
}

export default Orderview
